module.exports = __webpack_public_path__ + "static/media/Illus-Credit_1@2x.0898fb1c.png";